import { EventMessages } from '../constants';
import * as signUpFormData from '../data/alertsSignUpForm.json';
import { HttpStatusCode } from '../enums';
import Events from '../events';
import Rest from '../rest';

const advisoriesView = () => {
  if (!document.querySelector('.advisories')) {
    return;
  }

  const clearErrors = () => {
    const requiredMessages = document.querySelectorAll('.form__required-message');

    for (let index = 0; index < requiredMessages?.length; ++index) {
      const requiredMessage = requiredMessages[index];

      if (requiredMessage) {
        requiredMessage.classList.remove('form__required-message--visible');
      }
    }

    const invalidMessages = document.querySelectorAll('.form__invalid-message');

    for (let index = 0; index < invalidMessages?.length; ++index) {
      const invalidMessage = invalidMessages[index];

      if (invalidMessage) {
        invalidMessage.classList.remove('form__invalid-message--visible');
      }
    }
  };

  const challengeUser = () => {
    window.grecaptcha.execute();
  };

  const showErrorMessage = (field, group, errorClass, errorClassVisible) => {
    const errorMessage = group?.querySelector(`.${errorClass}`);

    if (errorMessage) {
      field.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      });
      field.focus();
      errorMessage.classList.add(errorClassVisible);
    }
  };

  const updateQueryString = (name, detail) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(name, detail);

    location.search = queryParams.toString();
  };

  const clearFilter = filter => {
    const queryStrings = new URLSearchParams(location.search);
    queryStrings.delete(filter);

    location.search = queryStrings.toString();
  };

  const submitForm = async token => {
    try {
      submitLoader.show = true;

      formData?.set('recaptchaResponse', token);

      const response = await Rest.post(`${process.env.API_ALERTS_SIGN_UP}/Store`, formData);

      if (response.status === HttpStatusCode.ok) {
        signupModal.show = false;
        submitLoader.show = false;

        const halfOfASecond = 500;
        const timeout = setTimeout(() => {
          clearTimeout(timeout);

          successModal.show = true;
        }, halfOfASecond);
      }
    } catch (error) {
      console.error(error);
    } finally {
      submitLoader.show = false;
      signUpForm.reset();
    }
  };

  let formData = null;
  const alertsSignUp = document.querySelector('.advisories__sign-up');
  const signUpForm = document.getElementById('sign-up-form');
  const successModal = document.getElementById('success-modal');
  const signupModal = document.getElementById('sign-up-modal');
  signupModal.onClose = () => {
    if (signUpForm) {
      signUpForm.reset();
    }
  };

  if (alertsSignUp) {
    const closeModal = document.querySelector('.advisories__modal-close');

    if (closeModal) {
      closeModal.addEventListener('click', () => {
        if (signupModal) {
          signupModal.show = false;
          signUpForm.reset();
        }
      });
    }

    alertsSignUp.addEventListener('click', () => {
      if (signupModal && closeModal) {
        signupModal.show = true;
      }
    });

    if (signUpForm) {
      signUpForm.formData = JSON.stringify(signUpFormData?.default?.forms[0]);
      signUpForm.addEventListener('on-submit', ({ detail }) => {
        formData = detail;
        challengeUser();
      });
    }
  }

  const clearFilters = document.querySelectorAll('.advisories__clear-filters');

  if (clearFilters) {
    const queryStrings = new URLSearchParams(location.search);

    for (let index = 0; index < clearFilters.length; ++index) {
      const clearFilter = clearFilters[index];
      clearFilter.addEventListener('click', () => {
        location.search = '';
      });

      if (queryStrings.get('locations')) {
        clearFilter.classList.add('advisories__clear-filters--visible');
      } else {
        clearFilter.classList.remove('advisories__clear-filters--visible');
      }
    }
  }

  const locationsFilter = document.querySelector('.locations-filter');

  if (locationsFilter) {
    locationsFilter.addEventListener('on-change', e => {
      if (e.target.value === 'undefined' || e.target.value.length === 0) clearFilter('locations');

      if (locationSelector.selectAllChecked)
       updateQueryString('locations', 'all');
      else 
       updateQueryString('locations', locationsFilter.value);
    });
    locationsFilter.addEventListener('on-clear', () => {
      clearFilter('locations');
    });
    locationsFilter.addEventListener('on-select-all', () => {
      updateQueryString('locations', locationsFilter.value);
    });
  }

  const locationSelector = document.querySelector('#location-selector');
  const locationSelectorSubmit = document.querySelector('#location-selector-submit');

  if (locationSelector && locationSelectorSubmit) {
    const initLocationSearch = () => {
      locationSelector.addEventListener('on-change', e => {
        if (e.target.value !== 'undefined' && e.target.value.length !== 0) clearErrors();
      });
      locationSelector.addEventListener('on-select-all', () => {
        clearErrors();
      });
    };

    const submitLocationSelection = () => {
      if (!locationSelector.value || locationSelector.value === 'undefined' || locationSelector.value.length === 0) {
        showErrorMessage(
          locationSelector,
          locationSelector.parentElement,
          'form__required-message',
          'form__required-message--visible'
        );

        return;
      }

      const loader = document.getElementById('advisories__loader');

      try {
        if (loader) loader.show = true;

          if (locationSelector.selectAllChecked)
              updateQueryString('locations', 'all');
          else 
              updateQueryString('locations', locationSelector.value);
      } catch (error) {
        console.error(error);
      } finally {
        if (loader) loader.show = false;
      }
    };

    initLocationSearch();
    locationSelectorSubmit.addEventListener('click', submitLocationSelection);
  }

  const sortBy = document.getElementById('sort-by');
  sortBy?.addEventListener('on-change', ({ detail }) => {
    const { value } = detail;

    updateQueryString('sortBy', value);
  });

  const modalDone = document.getElementById('modal-done');
  modalDone?.addEventListener('on-click', () => (successModal.show = false));

  const submitLoader = document.getElementById('submit-loader');

  Events.on(EventMessages.recaptchaValidate, token => submitForm(token));
};

export default advisoriesView;
